import { useContext } from 'react'
import { useMutation } from 'react-query'
import { apiPost, apiDelete, apiPatch } from 'api'
import AuthContext from 'context/auth-context'

const createAuditReportUser = async (token, params) => {
  const objectName = 'audit_report_user'
  const url = `audit_reports/${params.audit_report_id}/audit_report_users`

  apiPost({ url, token, objectName, params })
}

export function useCreateAuditReportUser({ params, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    () => {
      return createAuditReportUser(token, params)
    },
    { ...options }
  )
}

const destroyAuditReportUser = async (token, id) => {
  const url = `audit_report_users/${id}`

  apiDelete({ url, token })
}

export function useDestroyAuditReportUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    () => {
      return destroyAuditReportUser(token, id)
    },
    { ...options }
  )
}

const updateAuditReportUser = async (token, id, params) => {
  const objectName = 'audit_report_user'
  const url = `audit_report_users/${id}`

  return await apiPatch({ url, token, objectName, params })
}

export function useUpdateAuditReportUser({ id, options }) {
  const token = useContext(AuthContext)
  return useMutation(
    (params) => {
      return updateAuditReportUser(token, id, params)
    },
    { ...options }
  )
}
